<div class="pages-body login-page flex gap-2 sm:backgroundImg">

    <div *ngIf="!isMobile" class="hidden lg:block new-site-add h-full col-6">
        <new-site-add></new-site-add>
    </div>

    <div class="mx-auto flex flex-column mt-8">
        <div class="login-kesher-logo col-12 flex justify-content-center p-5">
            <img height="90" id="app-logo" src="assets/images/kesher_logo.png" alt="logo" />
        </div>

        <div class="align-self-center mb-auto">
            <div class="pages-panel card md:p-6 p-4 flex flex-column sm:w-35rem zoom">

                <h2>{{ getLabel() | translate }}</h2>

                <div class="input-panel flex flex-column px-3">

                    <login-panel *ngIf="mode == LoginMode.Login" #loginPanel
                        (mailVerficationClicked)="onMailVerficationClicked()" (submit)="loginProcess()"
                        [(loginModel)]="loginModel"></login-panel>

                    <new-user *ngIf="mode == LoginMode.New" #newUser
                        (verificationCodeSent)="verificationCodeSent($event)">
                    </new-user>

                    <code-verification *ngIf="mode == LoginMode.Forgot || mode == LoginMode.Verify" #codeVerify
                        [(verificationCode)]="loginModel.verificationCode"
                        (sendAgainVerificationCode)="sendAgainVerificationCode($event)"
                        (verificationCodeChange)="onVerificationCodeChange($event)"
                        [verificationCodeDetails]="verificationCodeDetails"
                        [(verificationType)]="loginModel.verificationType" [lightTitle]="true">
                    </code-verification>

                    <change-password *ngIf="mode == LoginMode.Change" #changePasswordPanel
                        (login)="loginFromNewPassword($event)"></change-password>

                    <login-buttons (clicked)="handleClick($event)" (cancelClicked)="back()"
                        (recoverPassword)="sendRecoverPasswordVerification()"
                        (sendAgainVerificationCode)="codeVerify.sendAgainClicked($event)"
                        (changeViewRequest)="changeView($event)" [mode]="mode"
                        [verificationType]="loginModel.verificationType"></login-buttons>

                    <re-captcha *ngIf="verificationRequired" [siteKey]="siteKeyV2"
                        (resolved)="onRecaptchaV2Resolved($event)">
                    </re-captcha>
                </div>
            </div>




        </div>
    </div>
    <contact-us class="fixed left-0 bottom-0 m-4 hidden md:flex"></contact-us>
</div>
<div class="text-left fixed px-2 version">{{version}}</div>